<template>
    <div>
        <DataTable :value="users" lazy paginator
                   v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset"
                   removableSort :totalRecords="totalRecords" :loading="loading" @page="onPage"
                   @sort="onPage" :rowsPerPageOptions="[5,10,20,50]" selection-mode="single" v-model:selection="selectedTableElement" @row-click="onRowSelect"
                   filterDisplay="row" class="user-table" scrollable
                   scrollHeight="calc(100vh - 300px)">
            <Column field="id" :header="$t('message.user.id')" :sortable="true" filterField="id"
                    :showFilterMenu="false" :showClearButton="false" class="w-2">
                <template #filter>
                    <CustomInputNumber name="id" v-model="searchCriteria.id" class="mb-0"
                                       @update:modelValue="search" />
                </template>
            </Column>
            <Column field="fullName" :header="$t('message.user.fullName')" :sortable="true" filterField="fullName"
                    :showFilterMenu="false" :showClearButton="false" class="w-2">
                <template #filter>
                    <CustomInputText name="fullName" v-model="searchCriteria.fullName" class="mb-0"
                                     @update:modelValue="search" />
                </template>
            </Column>
            <Column field="email" :header="$t('message.user.email')" :sortable="true" filterField="email"
                    :showFilterMenu="false" :showClearButton="false" class="w-3">
                <template #filter>
                    <CustomInputText name="email" v-model="searchCriteria.email" class="mb-0"
                                     @update:modelValue="search" />
                </template>
            </Column>
            <Column field="systemRole" :header="$t('message.user.userType')" filterField="systemRole"
                    :showFilterMenu="false" :showClearButton="false" class="w-2" sortable>
                <template #filter>
                    <CustomSelectOneSystemRole name="systemRole" v-model="searchCriteria.systemRole"
                                               class="mb-0" @update:modelValue="search" />
                </template>
                <template #body="{ data }">
                    {{ data.systemRoleName }}
                </template>
            </Column>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import {
        searchUser,
        searchUserCount,
    } from "@/swagger/vue-api-client";
    import CustomInputText from "@/components/form/CustomInputText.vue";
    import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
    import CustomSelectOneSystemRole from "@/components/form/CustomSelectOneSystemRole.vue";
    import CustomButton from "@/components/form/CustomButton.vue";
    import { ScrollToUtils } from "@/utils/ScrollToUtils";

    export default {
        name: "UserTable",
        components: {
            Column,
            DataTable,
            CustomButton,
            CustomInputNumber,
            CustomInputText,
            CustomSelectOneSystemRole,
        },

        props: {
            modelValue: null,
        },

        emits: ["update:modelValue", "showForm"],

        data() {
            return {
                loading: false,
                totalRecords: 0,
                users: [],
                searchCriteria: this.getClearSearchCriteria(),
                selectedTableElement: null,
            };
        },

        mounted() {
            this.updateTotalRecords();
            this.onPage(this.getFirstPage());
        },

        methods: {
            search() {
                this.onPage(this.getFirstPage());
                this.updateTotalRecords();
            },

            onPage(event) {
                this.loading = true;

                this.searchCriteria.page.offset = event.first;
                this.searchCriteria.page.limit = event.rows;
                this.searchCriteria.page.sortField = event.sortField;
                this.searchCriteria.page.sortOrder = event.sortOrder;

                searchUser({body: this.searchCriteria}).then((response) => {
                    this.users = response.data;
                    this.loading = false;
                });
            },

            updateTotalRecords() {
                searchUserCount({body: this.searchCriteria}).then((response) => {
                    this.totalRecords = response.data;
                });
            },

            getFirstPage() {
                return {
                    first: this.searchCriteria.page.offset,
                    rows: this.searchCriteria.page.limit,
                };
            },

            onRowSelect(event) {
                ScrollToUtils.scrollToElement();
                this.$emit("showForm");
                this.selectedUserType = event.data;
            },

            getClearSearchCriteria() {
                return {
                    id: null,
                    fullName: "",
                    email: "",
                    systemRole: null,
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                };
            },

            addNewUser() {
                this.selectedTableElement = null;
            },

            reloadTable() {
                this.search();
            },
        },

        computed: {
            selectedUserType: {
                get() { return this.modelValue; },
                set(value) { this.$emit("update:modelValue", value); },
            },
        },
    };
</script>

<style lang="scss">
    .user-table {
        .custom-select-one {
            margin-bottom: 0;
        }
    }
</style>
